import imageProductCategory1 from '../../images/01.png'
import imageProductCategory2 from '../../images/03.png'
import imageProductCategory3 from '../../images/02.png'
import imageProductCategory4 from '../../images/11.png'
import imageProductCategory5 from '../../images/09.png'

export const SHOP_DATA = {
    product_category_1: {
        id: 1,
        title: 'Product Category #1',
        routeName: 'product_category_1',
        items: [
            {
                id: '1_1',
                name: 'Product #1-1',
                image: imageProductCategory1,
                price: 10
            },
            {
                id: '1_2',
                name: 'Product #1-2',
                image: imageProductCategory1,
                price: 20
            },
            {
                id: '1_3',
                name: 'Product #1-3',
                image: imageProductCategory1,
                price: 30
            },
            {
                id: '1_4',
                name: 'Product #1-3',
                image: imageProductCategory1,
                price: 30
            },
            {
                id: '1_5',
                name: 'Product #1-3',
                image: imageProductCategory1,
                price: 30
            }
        ]
    },

    product_category_2: {
        id: 2,
        title: 'Product Category #2',
        routeName: 'product_category_2',
        items: [
            {
                id: '2_1',
                name: 'Product #2-1',
                image: imageProductCategory2,
                price: 10
            },
            {
                id: '2_2',
                name: 'Product #2-2',
                image: imageProductCategory2,
                price: 20
            },
            {
                id: '2_3',
                name: 'Product #2-3',
                image: imageProductCategory2,
                price: 30
            },
            {
                id: '2_4',
                name: 'Product #2-3',
                image: imageProductCategory2,
                price: 30
            }]
    },

    product_category_3: {
        id: 3,
        title: 'Product Category #3',
        routeName: 'product_category_3',
        items: [
            {
                id: '3_1',
                name: 'Product #3-1',
                image: imageProductCategory3,
                price: 10
            },
            {
                id: '3_2',
                name: 'Product #3-2',
                image: imageProductCategory3,
                price: 20
            },
            {
                id: '3_3',
                name: 'Product #3-3',
                image: imageProductCategory3,
                price: 30
            },
            {
                id: '3_4',
                name: 'Product #3-1',
                image: imageProductCategory3,
                price: 10
            },
            {
                id: '3_5',
                name: 'Product #3-2',
                image: imageProductCategory3,
                price: 20
            },
            {
                id: '3_6',
                name: 'Product #3-3',
                image: imageProductCategory3,
                price: 30
            }
        ]
    },

    product_category_4: {
        id: 4,
        title: 'Product Category #4',
        routeName: 'product_category_4',
        items: [
            {
                id: '4_1',
                name: 'Product #4-1',
                image: imageProductCategory4,
                price: 40
            },
            {
                id: '4_2',
                name: 'Product #4-2',
                image: imageProductCategory4,
                price: 20
            },
            {
                id: '4_3',
                name: 'Product #4-3',
                image: imageProductCategory4,
                price: 40
            },
            {
                id: '4_4',
                name: 'Product #4-1',
                image: imageProductCategory4,
                price: 10
            },
            {
                id: '4_5',
                name: 'Product #4-2',
                image: imageProductCategory4,
                price: 20
            },
            {
                id: '4_6',
                name: 'Product #4-3',
                image: imageProductCategory4,
                price: 40
            }
        ]
    },

    product_category_5: {
        id: 5,
        title: 'Product Category #5',
        routeName: 'product_category_5',
        items: [
            {
                id: '5_1',
                name: 'Product #5-1',
                image: imageProductCategory5,
                price: 50
            },
            {
                id: '5_2',
                name: 'Product #5-2',
                image: imageProductCategory5,
                price: 20
            },
            {
                id: '5_3',
                name: 'Product #5-3',
                image: imageProductCategory5,
                price: 30
            },
            {
                id: '5_4',
                name: 'Product #5-1',
                image: imageProductCategory5,
                price: 10
            },
            {
                id: '5_5',
                name: 'Product #5-2',
                image: imageProductCategory5,
                price: 20
            },
            {
                id: '5_6',
                name: 'Product #5-3',
                image: imageProductCategory5,
                price: 50
            }
        ]
    }
}